import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const CustomIconApple = (props: {}): JSX.Element => (
    <SvgIcon {...props}>
        <svg width={'24'} height={'24'} viewBox={'0 0 24 24'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
            <g id={'apple'}>
                <path
                    id={'Vector'}
                    d={
                        'M18.7108 19.5C17.8808 20.74 17.0008 21.95 15.6608 21.97C14.3208 22 13.8908 21.18 12.3708 21.18C10.8408 21.18 10.3708 21.95 9.10082 22C7.79082 22.05 6.80082 20.68 5.96082 19.47C4.25082 17 2.94082 12.45 4.70082 9.39C5.57082 7.87 7.13082 6.91 8.82082 6.88C10.1008 6.86 11.3208 7.75 12.1108 7.75C12.8908 7.75 14.3708 6.68 15.9208 6.84C16.5708 6.87 18.3908 7.1 19.5608 8.82C19.4708 8.88 17.3908 10.1 17.4108 12.63C17.4408 15.65 20.0608 16.66 20.0908 16.67C20.0608 16.74 19.6708 18.11 18.7108 19.5ZM13.0008 3.5C13.7308 2.67 14.9408 2.04 15.9408 2C16.0708 3.17 15.6008 4.35 14.9008 5.19C14.2108 6.04 13.0708 6.7 11.9508 6.61C11.8008 5.46 12.3608 4.26 13.0008 3.5Z'
                    }
                    fill={'black'}
                    fillOpacity={'0.9'}
                />
            </g>
        </svg>
    </SvgIcon>
);
